export default {
  root: {
    padding: '.8rem',
  },
};